import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { notifyOtaAppReady } from './lib/ota-updates.js';
import './styles/global.css';
import './styles/print.css';

// OTA rollback safety (native only): tell the updater this bundle booted OK.
// If a freshly-applied OTA bundle never reaches this call (white screen / crash
// on load), the plugin auto-reverts to the last good bundle on the next launch.
// Fire-and-forget so it never blocks first paint; no-op on web.
void notifyOtaAppReady();

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
